import { Box, Stack } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';

type SideNavbarHeaderProps = {
  isDrawerOpen: boolean;
};

export const SideNavbarHeader: React.FC<SideNavbarHeaderProps> = ({ isDrawerOpen }) => {
  return (
    <Stack
      sx={{
        padding: "24px",
        justifyContent: "center",
        height: "90px !important",
        position: 'relative',
        overflow: 'hidden'
      }}>
      <Box
        sx={{
          opacity: isDrawerOpen ? 1 : 0,
          transition: isDrawerOpen
            ? 'opacity 0.2s ease 0.15s'
            : 'opacity 0.15s ease',
        }}
      >
        <VyIcon
          icon="LogoSmall"
          style={{ width: '134px', height: '42px' }}
        />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: isDrawerOpen ? 0 : 1,
          transition: isDrawerOpen
            ? 'opacity 0.15s ease'
            : 'opacity 0.2s ease 0.15s',
          pointerEvents: 'none',
        }}
      >
        <VyIcon icon="VayuLogo" strokeOpacity={0} />
      </Box>
    </Stack>
  );
};
